import React, { useState } from "react";
import TextInputLabelHookForm from "components/TextInputLabelHookForm";
import { useFormContext } from "react-hook-form";
import { IHomeCompany } from "../types";
import { editStateHomeCompany } from "../atoms/atoms";
import { useRecoilValue } from "recoil";
import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { PERMISSIONS } from "modules/PermissionsConstants";

export const HomeCompanyDetails = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: IHomeCompany | undefined;
}) => {
  // Delete permission
  const userPermissions = useRecoilValue(permissionsSelector);
  const deletePermission =
    PERMISSIONS.permission_utilities_homecompany_type_delete;
  const hasDeletePermission = !userPermissions.includes(deletePermission);

  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStateHomeCompany);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [inputData, setInputData] = useState(data?.homeCompanyName || "");
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white shadow-lg h-full">
          <div className="grid grid-cols-6 mx-3 pb-2 gap-6 py-2">
            <div className="col-span-3 my-1">
              <TextInputLabelHookForm
                name="homeCompanyName"
                label="Home Company Name"
                type="text"
                onChange={(e) => {
                  setInputData(e.target.value);

                  if (
                    e.target.value.trim() === "" ||
                    (e.target.value === data?.homeCompanyName &&
                      checkBoxChanges == data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.homeCompanyName &&
                  formMethods.formState.errors.homeCompanyName.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("homeCompanyName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            {edit && (
              <div className="col-span-4 my-1 mx-3">
                <CheckBoxLabelHookForm
                  name="isActive"
                  disabled={
                    hasDeletePermission && data?.isActive === true
                      ? true
                      : false
                  }
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  type="checkbox"
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  onClick={(e) => {
                    if (!hasDeletePermission && data?.isActive) {
                      setCheckBoxChanges(e.target.checked);
                    }
                    if (
                      inputData?.trim() === "" ||
                      (e.target.checked === data?.isActive &&
                        inputData == data?.homeCompanyName)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeCompanyDetails;
